<template>
  <div class="template-profile-dropdown">
    <b-dropdown
      variant="link"
      :toggle-class="`text-decoration-none ${toggleClasses}`"
      no-caret
    >
      <template #button-content>
        <div
          v-if="photo"
          class="user-photo small"
          :style="`background-image: url(${photo})`"
        ></div>
        <div v-else :class="`user-circle ${theme}`">
          <span class="letter">{{ name[0] }}</span>
        </div>
      </template>
      <div class="header-info">
        <input-image id="profile-input-img" v-model="photo">
          <template #default>
            <div v-if="loading" class="user-photo picker">
              <b-spinner small variant="light" />
            </div>
            <div v-else :class="`user-circle ${theme} picker`">
              <span class="letter">{{ name[0] }}</span>
              <span class="edit"><i class="icon-edit-filled"></i></span>
            </div>
          </template>
          <template #filled-image>
            <div v-if="loading" class="user-photo">
              <b-spinner small variant="light" />
            </div>
            <div
              v-else-if="photo"
              class="user-photo"
              :style="`background-image: url(${photo})`"
            >
              <span class="edit"><i class="icon-edit-filled"></i></span>
            </div>
          </template>
        </input-image>
        <div class="pl-3 pt-3 text-truncate color">
          <p class="name mb-0">{{ name }}</p>
          <small class="email">{{ email }}</small>
        </div>
      </div>
      <div class="hr mt-2 mb-3"></div>
      <b-dropdown-item
        link-class="font-weight-normal"
        :to="{ name: 'account' }"
      >
        <i class="icon-user-filled"></i>Perfil
      </b-dropdown-item>
      <b-dropdown-item
        v-if="integrat_url"
        link-class="font-weight-normal"
        :href="integrat_url"
        target="_blank"
      >
        <i class="fa-solid fa-graduation-cap"></i> Secretaria
      </b-dropdown-item>
      <b-dropdown-item
        link-class="font-weight-normal"
        :to="{ name: 'my-list' }"
      >
        <i class="icon-plus"></i>Minha lista
      </b-dropdown-item>
      <!-- waiting backend -->
      <!-- <b-dropdown-item link-class="font-weight-normal" :href="notationsUrl">
        <i class="icon-note"></i>Minhas anotações
      </b-dropdown-item> -->
      <b-dropdown-item link-class="font-weight-normal" :href="clubUrl">
        <div class="d-flex align-items-center flex-fill">
          <i class="icon-three-dashes ml-n1 mr-1"></i>Meus cursos
        </div>
        <i class="icon-external-link text-primary"></i>
      </b-dropdown-item>
      <!-- <b-dropdown-item link-class="font-weight-normal" :href="certificatesUrl">
        <medal-icon class="mr-1 ml-n1 mr-1" /> Certificados
      </b-dropdown-item> -->
      <b-dropdown-item link-class="font-weight-normal" @click="$emit('faq')">
        <i class="icon-info mr-2"></i>FAQ
      </b-dropdown-item>
      <b-dropdown-item
        link-class="font-weight-normal"
        @click="$emit('support')"
      >
        <i class="icon-suport mr-2"></i>Suporte
      </b-dropdown-item>
      <div
        :class="{
          'mb-3': !integrat_url
        }"
      ></div>
      <b-dropdown-item link-class="font-weight-normal" @click="$emit('logout')">
        <i class="icon-power font-weight-bold red mr-2"></i
        ><span class="red">Sair</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
import InputImage from "@/components/InputImage";
// import { MedalIcon } from "@/assets/vueIcons";
import get from "lodash/get";
export default {
  data: () => ({ loading: false, integrat_url: null }),
  mounted() {
    this.$store.dispatch("user/getIntegratUrl").then(data => {
      this.integrat_url = data.url_login || null;
    });
  },
  components: {
    // MedalIcon,
    InputImage
  },
  props: {
    toggleClasses: {
      type: String,
      default: ""
    }
  },
  computed: {
    notationsUrl() {
      if (window.location.hostname.indexOf("staging.club") > -1) {
        return "https://staging.club.blitzpay.com.br/anotacoes";
      }
      return "https://club.blitzpay.com.br/anotacoes";
    },
    certificatesUrl() {
      if (window.location.hostname.indexOf("staging.club") > -1) {
        return "https://staging.club.blitzpay.com.br/certificados";
      }
      return "https://club.blitzpay.com.br/certificados";
    },
    clubUrl() {
      if (window.location.hostname.indexOf("staging.club") > -1) {
        return "https://staging.club.blitzpay.com.br";
      }
      return "https://club.blitzpay.com.br";
    },
    name() {
      return this.$user?.user?.name || "Usuário";
    },
    email() {
      return this.$user?.user?.email || "e-mail";
    },
    photo: {
      get() {
        return get(
          this.$user,
          "user.photo",
          get(this.$user, "user.user_photo", "")
        );
      },
      set(value) {
        this.loading = true;
        const payload = { photo: value };
        this.$store
          .dispatch("user/update", payload)
          .then(() => {
            this.$message.success("Sua foto de perfil foi atualizada!");
            this.$store.dispatch("user/get");
          })
          .catch(() => {
            this.$message.error("Erro ao atualizar sua foto de perfil!");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    theme() {
      return this.$setup.theme || "dark";
    }
  }
};
</script>
<style lang="scss" scoped>
.template-profile-dropdown {
  ::v-deep .dropdown-toggle::after {
    display: none;
  }

  ::v-deep .dropdown-menu {
    padding: 24px 16px;
    height: 355px;
    width: 294px;
  }

  ::v-deep .dropdown-item {
    padding: 4px 10px !important;
  }

  .header-info {
    display: flex;
    justify-content: center;
    padding: 3px 10px !important;
  }

  .user-circle {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #282237;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;

    .letter {
      color: var(--verso-dark-grey-1, #bebfc7);
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
    }

    i {
      font-size: 16px;
    }
    .icon-edit-filled {
      color: #fff !important;
    }
  }

  .red {
    color: var(--l-error-2, rgba(255, 117, 126, 0.86)) !important;
  }

  .user-photo {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;

    &.small {
      width: 36px !important;
      height: 36px !important;
    }
  }

  .picker {
    position: relative;
    width: 58px !important;
    height: 58px !important;

    .icon-user-filled {
      color: rgba(255, 255, 255, 0.8);
      font-size: 32px;
    }
  }

  .edit {
    position: absolute;
    bottom: -4%;
    right: -4%;
    background: #6b3ead;
    border-radius: 50%;
    width: 19px;
    height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 12px;
      color: var(--l-elevation-24);
    }
  }

  .name {
    font-size: 12px;
    font-weight: 600;
  }

  .email {
    font-size: 12px;
    font-weight: 400;
  }

  .hr {
    height: 1px;
    width: 100%;
    opacity: 0.4;
  }

  .icon-external-link,
  .icon-three-dashes {
    font-size: 24px;
  }
}
</style>
